<wr-split-view>
  <div left [nbSpinner]="!(data$|async)">
    <ng-content select="[listHeader]"></ng-content>
    <wr-list-view [items]="data$|async"
                  [selected]="selectedItem$|async"
                  (selectedChange)="selectedItem$.next($event); showingNewItem = false"
                  [searchText]="searchText"
                  (searchTextChange)="searchTextChange.emit($event)"
                  (addItemClicked)="addItemClicked.emit()"
                  [canCreate]="canCreate()"
    >
      <ng-template wrListItem let-item>
        <ng-container *ngIf="listItemTemplate?.templateRef as template; else noTemplate"
                      [ngTemplateOutlet]="template"
                      [ngTemplateOutletContext]="{$implicit: item}">
        </ng-container>
      </ng-template>
    </wr-list-view>
  </div>
  <div *ngIf="detailItem$|async as detail" right>
    <ng-container *ngIf="detailViewTemplate?.templateRef as template; else noTemplate"
                  [ngTemplateOutlet]="template"
                  [ngTemplateOutletContext]="{$implicit: detail}">
    </ng-container>
  </div>
  <div *ngIf="showingNewItem" right>
    <ng-container *ngIf="detailViewTemplate?.templateRef as template; else noTemplate"
                  [ngTemplateOutlet]="template"
                  [ngTemplateOutletContext]="{$implicit: null}">
    </ng-container>
  </div>
</wr-split-view>

<ng-template #noTemplate>
  <nb-alert status="warning">
    No template provided
  </nb-alert>
</ng-template>
